import { Stack } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getProducts } from '../../../actions/productsAction'
import { useActiveElements } from '../../../hooks/useActiveElements'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { setQuantity, setService, setSubTotal } from '../../../slices/orderSlice'
import { customStyles } from '../../../styles'
import { MainButton } from '../../helpers'

export const CilinderSize = () => {
  const dispatch = useDispatch()
  const { data } = useSelector(state => state.products)
  const { account } = useSelector(state => state.order)
  const { activeData, handleActive } = useActiveElements(data)
  const [authorization] = useLocalStorage('login-token', null)
  const { id } = useParams()
  
  const handleSizeCilinder = ( cilinder ) => {
    dispatch(setService(cilinder))
    handleActive(cilinder.id)
  }

  useEffect(() => {
    // data.length === 0 && account && dispatch(getProducts(account?.id, authorization?.token))
  }, [])


  useEffect(() => {
    if(data.length > 0 ){
      dispatch(setService(data[0]))
      dispatch(setQuantity(1))
      dispatch(setSubTotal(data[0].price))
      
    } 
  }, [data])
  
  // useEffect(() => {
  //   !account && dispatch(getProducts(id, authorization?.token))
  // }, [])

  return (
    <Stack direction="row" fullWidth spacing={1} justifyContent="center">
      {
        activeData.map(item => (
          <MainButton key={item.id} variant={ item.active ? 'contained' : '' } sx={{ backgroundColor: !item.active && customStyles.colors.backgroundColor }} text={`${item.capacity} kg`} sharp size="25%" height={40} onClick={() => handleSizeCilinder(item)}/>
        ))
      }
    </Stack>
  )
}
